import React, { useContext, useState } from "react";
import { View, StyleSheet } from "react-native";
import colors from "../../config/colors";
import UserContext from "../../context/UserContext";
import { useMobile } from "../../hooks/useMobile";
import { useNavigation } from "@react-navigation/native";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import routes from "../../navigation/routes";
import Logger from "../../common/utils/Logger";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtText from "../../components/NtText";

function NtNavigationBar({ sidebarCollapsed = false, onSidebarToggle }) {
  const context = useContext(UserContext);
  const nav = useNavigation();
  const isMobile = useMobile();

  return (
    <View style={styles.container}>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <NtTouchableEffect
          style={{}}
          onPress={() => {
            nav.navigate(routes.dashboard);
          }}
        >
          <NtText style={[styles.title]}>
            {context.organization?.name || "NTCONNECT"}
          </NtText>
        </NtTouchableEffect>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: "space-between",
    backgroundColor: colors.lighestGray,
    flexDirection: "row",
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 20,
    height: 60,
  },
  title: {
    fontSize: 22,
    fontWeight: "900",
    color: colors.almostBlack,
  },
});

export default NtNavigationBar;
